import { render, staticRenderFns } from "./ErrorContainer.vue?vue&type=template&id=2ca16fa9&scoped=true&"
import script from "./ErrorContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContainer.vue?vue&type=style&index=0&id=2ca16fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca16fa9",
  null
  
)

component.options.__file = "ErrorContainer.vue"
export default component.exports